import { render, staticRenderFns } from "./ClosureConfigSection.vue?vue&type=template&id=b16b2314&scoped=true"
import script from "./ClosureConfigSection.vue?vue&type=script&lang=js"
export * from "./ClosureConfigSection.vue?vue&type=script&lang=js"
import style0 from "./ClosureConfigSection.vue?vue&type=style&index=0&id=b16b2314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16b2314",
  null
  
)

export default component.exports